import { render } from "./WordListSort.vue?vue&type=template&id=86f43302&ts=true"
import script from "./WordListSort.vue?vue&type=script&lang=ts&setup=true"
export * from "./WordListSort.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/pages/word/components/WordListSort.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "86f43302"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('86f43302', __exports__)) {
    api.reload('86f43302', __exports__)
  }
  
  module.hot.accept("./WordListSort.vue?vue&type=template&id=86f43302&ts=true", () => {
    api.rerender('86f43302', render)
  })

}


export default __exports__